module.exports = __webpack_public_path__ + "28b49f504746fdc197ec63357db80854.pdf";